class AccountSettings.TicketValidationRules extends Backbone.Model
  urlRoot: '/keepcon/settings/ticket_validation_rules'
  defaults:
    ticket_attributes: []
    user_profile_attributes: []

  parse: (response) ->
    MODEL = AccountSettings.AttributeValidationRulesCollection
    ticket_attributes: new MODEL(response.ticket_attributes)
    user_profile_attributes: new MODEL(response.user_profile_attributes)

